export default __webpack_public_path__ + "static/media/up.aa8b0f94.png";